import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class MakeBetsState extends BaseState {

  begin() {
    Signals.socketClosed.add(this.onSocketClosed, this)
    Signals.forceRoundStart.add(this.onForceRoundStart, this)
    Signals.makeBets.dispatch()
    Facade.isPlaneStarted = false
    Facade.state = 'progress'
    Facade.model.bonusMultiplier = 1


    /*this.timeOut = setTimeout(() => {
      this.onForceRoundStart()
    }, Facade.model.makeBetsTime * 1000)*/
  }

  onForceRoundStart() {
    clearTimeout(this.timeOut)
    Signals.forceRoundStart.remove(this.onForceRoundStart, this)
    this.stateMachine.setState(GameStatesEnum.ROUND_START)
  }

  onSocketClosed() {
    this.stateMachine.setState(GameStatesEnum.RECONNECT_SOCKET)
  }

  cleanUp() {
    Signals.forceRoundStart.remove(this.onForceRoundStart, this)
    Signals.socketClosed.remove(this.onSocketClosed, this)
  }
}
